import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesRetiros() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Socios", icon: "fas fa-users", color: "#0d9488", href: "/Socios", enabled: !!(user.menuSocios) },
      { label: "Por Retirar", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/PorRetirar", enabled: !!(user.menuSocios) },
      { label: "Retiros", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/Retiros", enabled: !!(user.menuSocios) },
      { label: "Sociedades", icon: "fas fa-building", color: "#0d9488", href: "/Sociedades", enabled: !!(user.menuSocios) },
      { label: "Compra Venta", icon: "fas fa-handshake", color: "#0d9488", href: "/ListadoCompraVenta", enabled: !!(user.menuSocios) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Socios"
      descripcion="Socios, retiros y sociedades"
      icono="fas fa-users"
      color="#0d9488"
      secciones={secciones}
    />
  );
}

export default BotonesRetiros;
